import { useFormContext, useWatch } from 'react-hook-form';
import { AccountType, DefaultAssetAllocationDTO } from '../../api/useAccountsOptionsQuery';
import { useAccountFormContext } from '../AccountPreferences/components/AccountForm/context/useAccountFormContext';
import {
  FormFields,
} from '../AccountPreferences/components/AccountForm/AccountForm.meta';
import { EXCLUDE_OPTION } from '../AccountPreferences/components/AccountForm/components/AssetBucketing/AssetBucketing.meta';
import { TaxStatusDTO } from '../../api/useAccountsQuery';

export const useHoldings = () => {
  const {
    options: {
      AvailableAssetBuckets,
      DefaultAssetAllocation,
      DefaultAssetBucketingIndices,
      DefaultAssetBucketingIndicesByTaxStatus,
    },
  } = useAccountFormContext();

  const { control } = useFormContext<FormFields>();

  const accountType = useWatch({
    name: 'bankAccount.AccountType',
    control,
  });

  const isLinkedAccount = useWatch({
    name: 'bankAccount.IsLinked',
    control,
  });

  const isOrionManagedAccount = useWatch({
    name: 'bankAccount.IsOrionManagedAccount',
    control,
  });

  const taxStatus = useWatch({
    name: 'bankAccount.TaxStatus',
    control,
  });

  if (accountType === null || accountType === undefined) {
    throw new Error('Account type not found');
  }

  const assetAllocationDefaultOptions = DefaultAssetAllocation.find(
    defaults => defaults.AccountType === accountType,
  ) as DefaultAssetAllocationDTO;

  const defaultAssetAllocations = assetAllocationDefaultOptions.AssetAllocation.map(allocation => ({
    ...allocation,
    y: allocation.y * 100,
  }));

  const assetBucketOptions = AvailableAssetBuckets.map(({ Title }, index) => ({
    label: Title,
    value: index,
  }));

  const availableAssetBuckets = [...assetBucketOptions, EXCLUDE_OPTION].map(base => {
    if (taxStatus !== null && DefaultAssetBucketingIndicesByTaxStatus[AccountType[accountType]]) {
      return {
        ...base,
        rightLabel:
          base.value ===
          DefaultAssetBucketingIndicesByTaxStatus[AccountType[accountType]][TaxStatusDTO[taxStatus]]
            ? 'Default'
            : undefined,
      };
    }

    return {
      ...base,
      rightLabel:
        base.value === DefaultAssetBucketingIndices[AccountType[accountType]]
          ? 'Default'
          : undefined,
    };
  });

  const defaultAssetBucketIndex =
    availableAssetBuckets.find(option => option.rightLabel)?.value ?? null;

  return {
    data: {
      defaultAssetAllocations,
      defaultAssetBucketIndex,
      availableAssetBuckets,
      isLinkedAccount,
      isOrionManagedAccount,
    },
  };
};
